export default {
  column: 'Column',
  columns: 'Columns',
  verbose_column: 'a column',
  general_info: 'General information',

  blocks: 'Blocks',
  slide_per_view: '# Slide per view',
  slide_per_group: '# Slide per group',
  loop_circuit: 'Infinite carousel loop',
  auto_height: 'Carousel auto height',
  auto_play: 'Carousel auto play',
};
